/**
 * Class description
 *
 * Created: 2017-10-06
 * @author jonas
 */
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {FontStyle, FontType, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class FruitsFontConfig {

    public static getConfig():IFontsConfig {
        const openSansBaseUrl:string = "fonts/openSans/";
        const openSansWeightsToLoad:{ weight:FontWeight, fileSuffix:string, italic?:boolean }[] = [
            {weight : FontWeight.LIGHT, italic : true, fileSuffix : "Light"},
            {weight : FontWeight.NORMAL, italic : true, fileSuffix : "Regular"},
            {weight : FontWeight.SEMI_BOLD, italic : true, fileSuffix : "SemiBold"},
            {weight : FontWeight.BOLD, italic : false, fileSuffix : "Bold"},
            {weight : FontWeight.EXTRA_BOLD, italic : true, fileSuffix : "ExtraBold"}
        ];

        let config:IFontsConfig = {};

        for(let openSansWeight of openSansWeightsToLoad) {
            config["openSans" + openSansWeight.weight] = {
                fontFamily : "Open Sans",
                src : [
                    {
                        url : openSansBaseUrl + "OpenSans-" + openSansWeight.fileSuffix + ".woff2",
                        format : FontType.WOFF2
                    },
                    {url : openSansBaseUrl + "OpenSans-" + openSansWeight.fileSuffix + ".woff", format : FontType.WOFF}
                ],
                fontWeight : openSansWeight.weight
            };

            if(openSansWeight.italic) {
                config["openSans" + openSansWeight.weight + "Italic"] = {
                    fontFamily : "Open Sans",
                    src : [
                        {
                            url : openSansBaseUrl + "OpenSans-" + openSansWeight.fileSuffix + "Italic" + ".woff2",
                            format : FontType.WOFF2
                        },
                        {
                            url : openSansBaseUrl + "OpenSans-" + openSansWeight.fileSuffix + "Italic" + ".woff",
                            format : FontType.WOFF
                        }
                    ],
                    fontWeight : openSansWeight.weight,
                    fontStyle : FontStyle.ITALIC
                };
            }
        }

        return config;
    }
}